// import fetch from 'auth/FetchInterceptor'

// const AuthService = {}

// AuthService.login = function (data) {
// 	return fetch({
// 		url: '/auth/login',
// 		method: 'post',
// 		data: data
// 	})
// }

// AuthService.register = function (data) {
// 	return fetch({
// 		url: '/auth/register',
// 		method: 'post',
// 		data: data
// 	})
// }

// AuthService.logout = function () {
// 	return fetch({
// 		url: '/auth/logout',
// 		method: 'post'
// 	})
// }

// AuthService.loginInOAuth = function () {
// 	return fetch({
// 		url: '/auth/loginInOAuth',
// 		method: 'post'
// 	})
// }

// export default AuthService;

import axios from 'axios';

const AuthService = {}
const BASE_URL = process.env.REACT_APP_PLATFORM_API_URL || 'http://localhost:8000';

AuthService.login = function (data) {
    //console.log('Login attempt with:', data);

    return axios({
        url: `${BASE_URL}/api/auth/login`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            username: data.username || data.email,
            password: data.password
        }
    });
}

AuthService.register = function (data) {
    return axios({
        url: `${BASE_URL}/api/auth/signup`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            username: data.username || data.email,
            password: data.password
        }
    });
}

AuthService.getAllProjects = function (token) {
    return axios({
        url: `${BASE_URL}/api/project-list`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

AuthService.getProjectsByUser = function (token) {
    return axios({
        url: `${BASE_URL}/api/users/projects`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

AuthService.activeProjectStatus = function (token, projectID, enabled) {
    return axios({
        url: `${BASE_URL}/api/users/project-status`,
        method: 'put',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: {
            projectID: projectID,
            enabled: enabled
        }
    });
};

// TikTok OAuth methods
AuthService.initiateTikTokLogin = function () {
    return axios({
        url: `${BASE_URL}/api/auth/tiktok`,
        method: 'get'
    });
};

AuthService.getUserInfo = function (token) {
    return axios({
        url: `${BASE_URL}/api/user/info`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
};

AuthService.activeLiveStream = function (token, enabled) {
    return axios({
        url: `${BASE_URL}/api/users/livestatus`,
        method: 'put',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: {
            liveStatus: enabled
        }
    });
};

AuthService.getLiveStatus = function (token) {
    return axios({
        url: `${BASE_URL}/api/users/livestatus`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

AuthService.getTikTokDataHistory = function (token) {
    return axios({
        url: `${BASE_URL}/api/users/get-result-data`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

AuthService.getProjectIdsAllUsers = function (token) {
    return axios({
        url: `${BASE_URL}/api/getProjectIdsAllUsers`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

AuthService.updateUserProjects = function (token, data) {
    return axios({
        url: `${BASE_URL}/api/manageProjectForUser`,  
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    });
}


export default AuthService;